export default class VoidAndReissueParamsItem
{
	constructor(item) 
	{
		this.Ids=item.ids;
		this.Reason=item.reason;
		this.Surcharge=item.surcharge;
	}

}
